<script>
  import DataTool from "./Tool.svelte";
  import { FontsUrban, Theme } from "@urbaninstitute/dataviz-components";
</script>

<svelte:options customElement={{ tag: "data-tool" }} />

<FontsUrban />
<Theme>
  <DataTool />
</Theme>
